exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".complect[data-v-6ea188a8]{font-weight:700}", ""]);

// exports
